import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconUserStar } from "@tabler/icons-react";
import { ClientesDef } from "./ClientesDef";

export const ClientesHelpText = '* Aquí puede ver la lista de clientes.';
export const ClientesIcon = IconUserStar;
export class Clientes extends Entity<ClientesDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ClientesDef(), parentKeys);
        this.Form = import('./ClientesForm').then((module) => module.ClientesForm);
        this.Icon = ClientesIcon;
        this.HelpText = ClientesHelpText;
    }
}